export const CONFIG_FILENAME = 'config.json';
